import { assistancePhone, assistancePhoneLabel, registrationLink, Views } from './LoginForm.const';
import { ContentFooter, Text } from './LoginForm.styles';

const FormFooter = (props: { view: Views }) => {
  const { view } = props;
  return (
    <ContentFooter>
      {view !== Views.otp_code && (
        <Text>
          New here? <a href={registrationLink}>Register</a>
        </Text>
      )}
      <Text>
        For assistance call us at{' '}
        <a href={assistancePhone}>
          <u>{assistancePhoneLabel}</u>
        </a>
      </Text>
    </ContentFooter>
  );
};

export default FormFooter;
